module.exports = __webpack_public_path__ + "img/aim.497ef5bb.svg";